var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cn-drivers-list"},[_c('div',{staticClass:"cn-drivers-list__content"},[(_vm.loading)?_vm._l((6),function(i){return _c('div',{key:i},[_c('DriverCardSkeleton')],1)}):[_vm._t("default")]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }